import React from "react"
import styled from "@emotion/styled"
import { OutboundLink } from "gatsby-plugin-google-gtag"

const Footer = () => {
  return (
    <footer className="footer">
      <FooterContent className="content has-text-centered">
        <p>
          {" "}
          <small>&copy; {new Date().getFullYear()} Ubiquitools LLC</small>
        </p>
        <p>
          <small>
            Looking For Sponsor v2.0.5 | Built with{" "}
            <OutboundLink href="https://www.gatsbyjs.org/">Gatsby</OutboundLink>
          </small>
        </p>
      </FooterContent>
    </footer>
  )
}

const FooterContent = styled.div`
  p {
    margin-bottom: 5px !important;
  }
`

export default Footer
